import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StreamService } from 'src/app/services/stream.service';
import { Stream } from 'src/app/models/stream';
import {MatDialog} from '@angular/material/dialog';
import { CoursePickerComponent } from 'src/app/components/modals/course-picker/course-picker.component';
import { ProgrammeCourse } from 'src/app/models/programmeCourse';
import { StreamCourse } from 'src/app/models/streamCourse';
import { StreamEditorComponent } from 'src/app/components/modals/stream-editor/stream-editor.component';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import {MatSnackBar} from '@angular/material/snack-bar';
import { AddCoursesComponent } from 'src/app/components/modals/add-courses/add-courses.component';
import { CategoryService } from 'src/app/services/category.service';
import { SupporterService } from 'src/app/services/supporter.service';
import { TagsService } from 'src/app/services/tags.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-stream',
  templateUrl: './stream.component.html',
  styleUrls: ['./stream.component.scss']
})
export class StreamComponent implements OnInit {
  public stream_id;
  public loadedStream: boolean = false;
  public stream: Stream;
  public isNew:boolean = false;
  public Editor = ClassicEditor;
  public categories=[];
  public supporters=[];
  public newDiscount={
    type: 'amount',
    amount: 0,
    code: '',
    valid_from: '',
    expires_on: '',
    one_per_user: 0,
    max_uses: 0
  };
  public showDiscountUsers=[];
  public streamTags=[];
  public tags=[];
  dropdownSettings:IDropdownSettings;
  dropdownSettings2:IDropdownSettings={
    idField: 'id',
    textField: 'role'
  };
  public streamRoles=[];
  public roleVet:boolean=false;
  public roleVetNurse:boolean=false;
  public roleNonClinical:boolean=false;
  public roles=[{id:1,role:'Vet'}, {id:2,role:'Vet Nurse'}, {id:3,role:'Non Clinical'}];

  constructor(
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private streamService: StreamService,
    private supporterService: SupporterService,
    private _router: Router,
    private _notify: MatSnackBar,
    private _cat: CategoryService,
    private _tag: TagsService
  ) {
    this.stream_id = this.route.snapshot.paramMap.get("id");
  }

  public catSelected(c1: any, c2:any) {
    return c1.id==c2.id;
  }

  public supporterSelected(s1: any, s2:any) {
    return s1.id==s2.id;
  }

  public seriesStatus(s1:any, s2:any){
    // console.log(s1, s2)
    return s1==s2;
  }

  public notify(message:string, action:string) {
    this._notify.open(message, action, {
      duration: 4000,
      verticalPosition: 'top'
    });
  }

  ngOnInit() {
    this._cat.getCategories().subscribe(
      res=>{
        this.categories=res;
      }
    );
    this.supporterService.getSupporters().subscribe(
      (data:any) => {
        this.supporters=data;
      }
    );
    this._tag.getPaginatedTags(1,99999999,'').subscribe(
      res=>{
        this.tags=res.data;
      }
    );
    if (this.stream_id>0) {
      this.getStream();
    } else {
      this.stream=new Stream({});
      this.stream.name='New Stream';
      this.stream.published=false;
      this.isNew=true;
      //this.streamEditor();
      this.loadedStream=true;
    }
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'tag',
      enableCheckAll: false,
      searchPlaceholderText: 'Filter tags',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
  }

  deleteStream(){
    if(confirm('Confirm deletion of this Series')) {
      this.streamService.deleteStream(this.stream.id).subscribe(res => {
        if(res.message == 'Deleted') {
          this._router.navigate(['/streams/']);
        }
      });
    }
  }

  addDiscount(){
    if(
      this.newDiscount.code == ''
      || this.newDiscount.amount < 1
    ) {
      return this.notify('A discount must have at least a code and an amount.', 'OK');
    }
    this.streamService.addDiscount(this.stream_id, this.newDiscount).subscribe(
      res=>{
        this.newDiscount={
          type: 'amount',
          amount: 0,
          code: '',
          valid_from: '',
          expires_on: '',
          one_per_user: 0,
          max_uses: 0
        };
        this.getStream();
      }
    );
  }

  deleteDiscount(discountId:number){
    if(confirm('Confirm deletion of this discount?')){
      this.streamService.deleteDiscount(discountId, this.stream_id).subscribe(
        res=>{
          this.getStream();
        }
      );
    }
  }

  getStream(){
    this.streamService.getStream(this.stream_id,"include=courses.course,category,supporter,discount.users.user").subscribe(res=>{
      this.stream = res;
      if(this.stream.tags) this.stream.tags.forEach(item=>{
        // console.log(item.id);
        // this.streamTags[item.id]=item;
        this.streamTags.push(item);
      });
      this.streamTags=[...new Map(this.streamTags.map(item => [item['id'], item])).values()];
      console.log(this.streamTags);
      this.stream.user_roles.forEach(item=>{ this.streamRoles[item.id]=true; });
      this.loadedStream = true;
    })
  }

  saveNewStream(stream: Stream){
    this.stream.tags=this.streamTags;
    this.stream.user_roles=this.streamRoles;
    this.streamService.addStream(stream).subscribe(res => {
      this._router.navigate(['/streams/'+res.id]);
      this.stream_id = res.id;
      this.getStream();
      this.isNew=false;
    });
  }

  streamEditor(){
    this.stream.tags=this.streamTags;
    this.stream.user_roles=this.streamRoles;
    if(this.stream.name=='' || this.stream.description==''){
      this.notify('A series must have a title and description','OK');
      return;
    }
    if (this.isNew) {
      this.saveNewStream(this.stream);
    } else {
      this.streamService.updateStream(this.stream).subscribe(res => {
        this.getStream();
        this.notify('Stream updated.', 'OK');
      });
    }
    this._router.navigate(['/streams']);
  }

  coursePicker(){
    if (this.isNew) return alert('Please save new Stream before adding courses.');
    const dialogRef = this.dialog.open(AddCoursesComponent, {
      width: '450px',
      panelClass: 'ng-modal-custom'
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        result.forEach(course=>{
          let streamCourse = new StreamCourse;
          streamCourse.course_id = course.id;
          streamCourse.stream_id = this.stream.id;
          this.streamService.addCourse(streamCourse).subscribe(res=>{
            this.getStream();
          })
        });
        // this.getStream();
        this.notify('Courses updated.', 'OK');
      }
    });
  }

  public setPosUp(index:number)
  {
    let swap = index-1;
    this.stream.courses.forEach((c:any, i)=>{
      if(i==index) c.position=swap;
      if(i==swap) c.position=index;
      if(i!=index && i!=swap) c.position=i;
    });
    this.streamEditor();
  }

  public setPosDown(index:number)
  {
    let swap = index+1;
    this.stream.courses.forEach((c:any, i)=>{
      if(i==index) c.position=swap;
      if(i==swap) c.position=index;
      if(i!=index && i!=swap) c.position=i;
    });
    this.streamEditor();
  }

  removeCourse(stream_course: StreamCourse ){
    if(!confirm('Confirm you want to remove this course.')) return false;
    this.stream.courses=this.stream.courses.filter((s:any)=>{
      //console.log(s.course_id, stream_course.course_id);
      return s.course_id != stream_course.course_id;
    });
    this.streamService.deleteCourse(stream_course).subscribe(res=>{
      this.streamEditor();
    })
  }

}
